import React, { useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import dummyLogo from "./../assets/logo.webp";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
} from "react-icons/fa";
import {Helmet} from "react-helmet-async";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [bycommitment, setByCommitment] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!acceptedTerms) {
      setTermsError(true);
      return;
    }
    setLoading(true);
    setSuccess(false);

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbxN_3PpNDT48fcZ_Wd6ebWe7u75vulFJpb0FOa2x_YMGvNz7lGvNuNxwgdzfC6_hyk8Gw/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        },
      );

      setSuccess(true);

      

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    
    } catch (error) {
      console.error("Error!", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Helmet>
      <style>{`
        @keyframes fadeInDown {
          0% {
            opacity: 0;
            transform: translateY(-30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes expandWidth {
          0% {
            width: 0px;
          }
          100% {
            width: 150px;
          }
        }
        .animate-fade-in-down {
          opacity: 0;
          animation: fadeInDown 0.8s cubic-bezier(0.25, 1, 0.5, 1) forwards;
        }
        .animate-fade-in-up {
          opacity: 0;
          animation: fadeInUp 0.8s cubic-bezier(0.25, 1, 0.5, 1) forwards;
          animation-delay: 0.4s;
        }
        .animate-expand-width {
          animation: expandWidth 1s cubic-bezier(0.25, 1, 0.5, 1) forwards;
          animation-delay: 0.2s;
        }
      `}</style>
    </Helmet>
      <Header />
      <main className="w-full flex justify-center items-center flex-col">
        <header className="relative w-full h-[35vh] md:h-[45vh] bg-gradient-to-br from-[#c61d21] via-[#aa161a] to-[#800c0f] flex flex-col justify-center items-center overflow-hidden shadow-md">
          {/* Decorative glowing background details */}
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_rgba(249,200,52,0.15)_0%,_transparent_60%)] animate-pulse" style={{ animationDuration: '8s' }}></div>
          <div className="absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-yellow-400/5 blur-3xl"></div>
          <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-red-400/10 blur-3xl"></div>

          <div className="relative z-10 flex flex-col items-center text-center px-4">
            <h1 className="text-white font-playfair font-bold text-[2.5rem] md:text-[4rem] tracking-wide animate-fade-in-down drop-shadow-md">
              Contact Us
            </h1>
            <div className="h-[3px] bg-gradient-to-r from-transparent via-[#f9c834] to-transparent w-0 animate-expand-width mt-3 mb-4 rounded-full"></div>
            <p className="text-[#f2e7db] font-inter font-light text-[1rem] md:text-[1.3rem] max-w-xl animate-fade-in-up">
              Get in touch with ISKCON Vijayawada Devotional Family
            </p>
          </div>
        </header>
        <div className="w-[90%] md:w-[70%] flex flex-col justify-center items-center py-[5%] md:py-[3%]">
          <h1 className="text-center text-[#c61d21] font-playfair font-semibold text-[1.6rem] md:text-[2.2rem]">
            HERE TO SERVE YOU
          </h1>

          <p className="text-center text-[#393737] font-inter font-normal text-[1.1rem] md:text-[1.6rem] px-[5%] md:px-0">
            We are so happy that you took the time to visit us and we welcome
            you to the IsKCON Vijayawada devotional family .Please write to us
            for any questions , to offer you services to Sri Sri Radha Madhava ,
            for information of any of our services and courses , or any
            suggestion . We are here to serve you , Hare Krishna!
          </p>

          <div className="w-[30%] md:w-[20%] h-1 bg-[#c61d21]"></div>
        </div>

        <>
          {loading && (
            <div className="fixed top-0 left-0 w-full h-full bg-white/85 flex justify-center items-center z-[9999]">
              <div className="w-[60px] h-[60px] border-[6px] border-gray-200 border-t-[#c61d21] rounded-full animate-spin"></div>
            </div>
          )}

          <div className="w-full flex justify-center py-10">
            <div className="w-full max-w-[1200px] flex justify-between gap-10 bg-[#c61d21] rounded-[10px] p-[30px] md:p-5 flex-wrap">
              {/* Left Section */}
              <div className="flex-1 min-w-[300px] w-full md:w-auto text-center flex flex-col justify-center gap-5 text-white">
                <img
                  src={dummyLogo}
                  alt="Logo"
                  className="w-[150px] md:w-[180px] mx-auto"
                />

                <div>
                  <div className="flex items-center justify-center gap-2 mb-[5px]">
                    <FaMapMarkerAlt className="w-5 h-5" />
                    <h5 className="m-0 text-base font-semibold text-[#f9c834]">
                      ISKCON SRI RADHA SHYAM SUNDAR MANDIR
                    </h5>
                  </div>
                  <h6 className="m-0 font-normal">
                    <a
                      href="https://maps.app.goo.gl/viF4YDydn2SDzRi28"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white no-underline text-sm"
                    >
                      Main Temple - Amaravathi Karakatta Road, Undavalli,
                      Vijayawada, 522 501
                    </a>
                  </h6>

                  <div className="flex items-center justify-center gap-2 mb-[5px] mt-4">
                    <FaMapMarkerAlt className="w-5 h-5" />
                    <h5 className="m-0 text-base font-semibold text-[#f9c834]">
                      ISKCON SRI JAGANNATH MANDIR
                    </h5>
                  </div>
                  <h6 className="m-0 font-normal">
                    <a
                      href="https://maps.app.goo.gl/c3hFWvqTRbtSXtW8A"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white no-underline text-sm"
                    >
                      City Temple - Skew Bridge, Krishna Lanka, Vijayawada -
                      520013
                    </a>
                  </h6>
                </div>

                <div className="mt-5 flex flex-col items-center gap-[15px]">
                  <div className="flex items-center justify-center gap-3 text-white text-lg flex-wrap text-center">
                    <FaPhoneAlt className="w-6 h-6" />
                    <span>Call: 8006880038</span>
                  </div>
                  <div className="flex items-center justify-center gap-3 text-white text-lg flex-wrap text-center">
                    <FaWhatsapp className="w-6 h-6" />
                    <span>Whatsapp: 9955685568</span>
                  </div>
                  <div className="flex items-center justify-center gap-3 text-white text-lg flex-wrap text-center">
                    <FaEnvelope className="w-6 h-6" />
                    <span>Email: seva@iskconvijayawada.org</span>
                  </div>
                </div>
              </div>

              {/* Right Side - Form */}
              <form
                className="flex-1 min-w-[300px] w-full md:w-auto bg-[#c61d21] p-5 rounded-[10px] text-white"
                onSubmit={handleSubmit}
              >
                <h2 className="mb-5 text-2xl md:text-[28px] font-semibold text-left md:text-left">
                  <span className="text-orange-500">CONTACT</span> FORM
                </h2>

                <div className="flex gap-[15px] mb-[15px] flex-wrap md:flex-nowrap">
                  <input
                    className="flex-1 min-w-[130px] w-full md:w-auto p-3 border border-gray-300 rounded text-base text-black"
                    type="text"
                    name="firstName"
                    placeholder="First Name *"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                  <input
                    className="flex-1 min-w-[130px] w-full md:w-auto p-3 border border-gray-300 rounded text-base text-black"
                    type="text"
                    name="lastName"
                    placeholder="Last Name *"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="flex gap-[15px] mb-[15px] flex-wrap md:flex-nowrap">
                  <input
                    className="flex-1 min-w-[130px] w-full md:w-auto p-3 border border-gray-300 rounded text-base text-black"
                    type="email"
                    name="email"
                    placeholder="Email *"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  <input
                    className="flex-1 min-w-[130px] w-full md:w-auto p-3 border border-gray-300 rounded text-base text-black"
                    type="text"
                    name="phone"
                    placeholder="Phone *"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <textarea
                  className="w-full p-3 h-[120px] border border-gray-300 rounded resize-none text-base text-black mb-[15px]"
                  name="message"
                  placeholder="Your Message *"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />

                <div className="mb-4">
                  <label className="flex items-center gap-2 text-[0.9rem] text-white">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      checked={acceptedTerms}
                      onChange={() => {
                        setAcceptedTerms(!acceptedTerms);
                        setTermsError(false);
                      }}
                    />

                    <span>
                      I accept all the{" "}
                      <span
                        onClick={() =>
                          navigate("/policies-usage/term--conditions")
                        }
                        className="text-yellow-400 cursor-pointer"
                      >
                        terms and conditions
                      </span>{" "}
                      and{" "}
                      <span
                        onClick={() =>
                          navigate("/policies-usage/term--conditions")
                        }
                        className="text-yellow-400 cursor-pointer"
                      >
                        privacy policy
                      </span>
                      .
                    </span>
                  </label>
                  {termsError && (
                    <p className="text-yellow-400 text-[0.8rem] mt-1">
                      You must accept the terms and conditions to submit.
                    </p>
                  )}
                </div>
                <div className="mb-4">
                  <label className="flex items-center gap-2 text-[0.9rem] text-white">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      checked={bycommitment}
                      onChange={() => {
                        setByCommitment(!bycommitment);
                      }}
                    />

                    <span>
                      By continuing, you agree to authorize our represetatives
                      to Call/Email/SMS/RCS/WhatsApp you regarding your
                      application
                    </span>
                  </label>
                </div>

                <button
                  className="bg-amber-500 text-white border-none py-3 px-6 rounded cursor-pointer text-base hover:bg-orange-600"
                  type="submit"
                >
                  SUBMIT
                </button>

                {success && (
                  <p className="text-[#00ff7f] mt-[15px] font-bold text-base">
                    Form submitted successfully!
                  </p>
                )}
              </form>
            </div>
          </div>
        </>
      </main>

      <Footer />
    </>
  );
};

export default ContactUs;
